import React from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";
import ReviewListContainer from "./Containers/ReviewListContainer";
import { Paginator, PaginatorElem } from "ComponentsUI/Pagination";
import Block from "ComponentsUI/Block";
import FiltersContainer from "./Containers/Filters";
import { graphql } from "@apollo/client/react/hoc";
import { compose } from "recompose";
import { REVIEWS_QUERY_V2, REGION_REVIEWS_FILTERS_QUERY } from "Services/queries";
import Routes from "Configs/routes";
import { generateUrl } from "Services/withDefaultParams";
import { variablesFromRouter } from "Services/QueryBuilder";
import queryString from "query-string";
import Stub from "./Containers/Stub";
import { Redirect404, RedirectPagination } from "ComponentsUI/Redirects";
import OneClick from "Containers/OneClick";
import { PaddingBottom } from "ComponentsUI/Spacings";
import configRouters from "Configs/routes";
import { Helmet } from "react-helmet-async";
import { sendMetriks } from "Services/sendMetriks";
import { isMainSiteCode } from "Utils/siteConfig";
import Container from "reactstrap/lib/Container";

const LIMIT = 20;

@inject("ApplicationModel")
@observer
class Reviews extends React.Component {
	canonical() {
		const {
			ApplicationModel: { siteConfig },
		} = this.props;

		const location = generateUrl(configRouters.Reviews.route, {
			regionUrl: this.props.match.params.regionUrl,
		});

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	}

	componentDidMount() {
		sendMetriks("OPEN_OTZYVY_REGION");
	}

	sendMecrtksClikc() {
		sendMetriks("OPEN_OTZYVY_REGION");
	}

	render() {
		let {
			ApplicationModel: { windowSizeModel, siteCode },
			data,
			match,
			reviewFilters,
		} = this.props;

		let page = 1;
		if (this.props.match.params.page > -1) {
			page = parseInt(this.props.match.params.page);
		}

		if (this.props.match.params.page === "1") {
			return <RedirectPagination />;
		}

		let pagination = !data.loading ? data.reviewsProvidersV2.pagination : null;

		let reviews = !data.loading ? data.reviewsProvidersV2.data : null;

		if (pagination) {
			let pageTotal = Math.ceil(pagination.items_total / 20);

			if (!page || pagination.items_total < LIMIT * (page - 1)) {
				return <Redirect404 message404={"Выбрана пагинация больше доступной в отзывах региона"} />;
			}
			pagination = {
				...pagination,
				per_page: 20,
				page_current: page,
				page_total: pageTotal,
			};
		}
		let path = generateUrl(Routes.Reviews.route, {
			regionUrl: match.params.regionUrl,
		});

		return (
			<>
				{this.canonical()}
				{isMainSiteCode(siteCode) && <div></div>}
				<Block>
					{!data.loading && (
						<Container>
							<OneClick />
						</Container>
					)}
					<FiltersContainer filters={reviewFilters} />
					{data.loading && !data.reviewsProvidersV2 ? (
						<Stub />
					) : (
						<ReviewListContainer items={reviews} withReply={true} />
					)}
				</Block>
				{!data.loading && (
					<Paginator
						location={this.props.location}
						itemsTotal={pagination.items_total}
						itemsPerPage={20}
						pageCurrent={pagination.page_current}
						pageTotal={pagination.page_total}
						windowSizes={windowSizeModel.windowSizes}
						urlDefault={path}
						wrapperItem={<PaginatorElem />}
						datatest="reviews"
						onChangePage={this.sendMecrtksClikc()}
					/>
				)}
			</>
		);
	}
}

export default withRouter(
	withDefaultParams(
		variablesFromRouter(
			compose(
				graphql(REVIEWS_QUERY_V2, {
					skip: (ownProps) => {
						return !ownProps.match.params.regionUrl;
					},
					options: (props) => {
						let params = queryString.parse(props.location.search);
						let sort = params.sort;
						let offset = props.match.params.page > 0 ? props.variables.offset : 0;

						return {
							variables: {
								...props.variables,
								offset: offset,
								sort: !sort ? "-date" : sort,
								providerJoin: true,
							},
						};
					},
				}),
				graphql(REGION_REVIEWS_FILTERS_QUERY, {
					skip: (ownProps) => {
						return !ownProps.match.params.regionUrl;
					},
					options: (props) => {
						let filters = [];
						if (props.match.params.regionUrl) {
							filters.push(`region_url=${props.match.params.regionUrl}`);
						}

						let params = queryString.parse(props.location.search);
						if (params.rating) {
							filters.push(`rating_type=${params.rating}`);
						}
						if (params.service) {
							filters.push(`service_id=${params.service}`);
						}
						if (params.providers) {
							filters.push(`provider_id=${params.providers}`);
						}

						return {
							variables: {
								filter: filters.join("&"),
							},
						};
					},
					props: ({ data }) => {
						if (data.regionReviewsFilters?.data) {
							return {
								reviewFilters: data.regionReviewsFilters.data,
							};
						}
						return null;
					},
				})
			)(Reviews),
			"-date"
		)
	)
);
